import React, { useEffect, useState } from 'react';

import { 
    ConnectBriefcaseWebSocket, 
    SetBriefcaseSocketMessageHandler, 
    ClearBriefcaseSocketMessageHandler, 
    DisconnectBriefcaseWebSocket, 
    SendMainBriefcaseSelection,
    SendTargetBriefcase 
} from '../../../utilities/BL/Briefcase'; // Ajusta la ruta a donde guardaste el archivo anterior


const Briefcase = () => {
    // ==========================================================================
    // ESTADOS
    // ==========================================================================
    const [connectionStatus, setConnectionStatus] = useState('connecting');
    const [toastMessage, setToastMessage] = useState('');
    const [isSending, setIsSending] = useState(false);

    // Estado del juego en vivo (sincronizado con el backend)
    const [matchState, setMatchState] = useState({
        phase: 'WAITING',
        briefcases: [],
        userSelectedBriefcaseId: null,
        suspenseBriefcaseId: null
    });

    // ==========================================================================
    // MANEJO DE WEBSOCKET
    // ==========================================================================
    useEffect(() => {
        const showToast = (msg) => {
            setToastMessage(msg);
            setTimeout(() => setToastMessage(''), 3000);
        };

        // Conectar al servidor automáticamente al entrar
        ConnectBriefcaseWebSocket(setConnectionStatus, showToast).then(() => {
            SetBriefcaseSocketMessageHandler(handleIncomingMessage);
        });

        return () => {
            ClearBriefcaseSocketMessageHandler();
            DisconnectBriefcaseWebSocket();
        };
    }, []);

    const handleIncomingMessage = (msg) => {
        const messageType = (msg?.type || '').toLowerCase();
        const payloadData = msg?.payload || {};

        if (messageType === 'briefcase.update') {
            setMatchState(payloadData);
        } else if (messageType === 'briefcase.reset') {
            setMatchState({ phase: 'WAITING', briefcases: [], userSelectedBriefcaseId: null, suspenseBriefcaseId: null });
        }
    };

    // ==========================================================================
    // ACCIONES DEL JUGADOR
    // ==========================================================================
    const handleBriefcaseSelection = async (briefcaseId) => {
        if (isSending) return;
        const targetBriefcase = matchState.briefcases.find(b => b.id === briefcaseId);
        if (!targetBriefcase || targetBriefcase.state !== 'closed') return;

        setIsSending(true);

        // PASO 1: Elegir el maletín propio
        if (matchState.phase === 'SELECTING_MAIN') {
            const response = await SendMainBriefcaseSelection(briefcaseId);
            if (!response.success) setToastMessage("Error al seleccionar. Intenta de nuevo.");
        } 
        // PASO 2: Elegir qué maletín abrir durante el juego
        else if (matchState.phase === 'OPENING_ROUNDS') {
            // No dejamos que el usuario marque su propio maletín para abrir (eso se hace hasta el final)
            if (matchState.userSelectedBriefcaseId === briefcaseId) {
                setIsSending(false);
                return;
            }
            const response = await SendTargetBriefcase(briefcaseId);
            if (!response.success) setToastMessage("Error al marcar maletín. Intenta de nuevo.");
        }
        
        setIsSending(false);
    };
    // const handleBriefcaseSelection = async (briefcaseId) => {
    //     // Solo puede seleccionar si la fase es correcta, si no hay envío en curso y si el maletín está cerrado
    //     if (matchState.phase !== 'SELECTING_MAIN' || isSending) return;
        
    //     const targetBriefcase = matchState.briefcases.find(b => b.id === briefcaseId);
    //     if (!targetBriefcase || targetBriefcase.state !== 'closed') return;

    //     setIsSending(true);
    //     const response = await SendMainBriefcaseSelection(briefcaseId);
        
    //     if (!response.success) {
    //         setToastMessage("Error al seleccionar. Intenta de nuevo.");
    //         setTimeout(() => setToastMessage(''), 3000);
    //     }
    //     setIsSending(false);
    // };

    // ==========================================================================
    // RENDERIZADO CONDICIONAL Y ESTILOS
    // ==========================================================================
    const ASSETS = {
        closed: '/img/games/briefcase/cerrado.png',
        opened: '/img/games/briefcase/abierto.png',
        bg: '/img/games/briefcase/background.jpg'
    };

    // Mensaje de cabecera según la fase
    const getInstructionText = () => {
        switch (matchState.phase) {
            case 'WAITING': return "¡Prepárate! El juego está por comenzar";
            case 'SELECTING_MAIN': return "Elige tu maletín";
            case 'OPENING_ROUNDS': return ""; //"¡El animador está abriendo maletines!";
            case 'SUSPENSE': return ""; //"¡Suspenso...!";
            case 'REVEAL_MODAL': return "Checa la pantalla del estadio";
            case 'FINISHED': return "Juego finalizado. Gracias por jugar con nosotros";
            default: return "Cargando...";
        }
    };

    return (
        <div className="briefcase-fan" style={{
            position: 'relative', width: '100vw', height: '100vh', 
            backgroundColor: '#020617', color: 'white', overflow: 'hidden',
            fontFamily: 'system-ui, sans-serif'
        }}>
            {/* Fondo oscuro/difuminado para el celular */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                backgroundImage: `url(${ASSETS.bg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
                filter: 'brightness(0.3) blur(2px)', zIndex: 1
            }}></div>

            <div style={{ position: 'relative', zIndex: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                
                {/* CABECERA (Status y Mensaje) */}
                <header style={{ padding: '15px', textAlign: 'center' }}> {/* backgroundColor: 'rgba(0,0,0,0.6)', borderBottom: '2px solid #ffd700' */}
                    <img src="/img/page/xolos-five.png" className="LogoADSLxZtudia" alt="Logo" />

                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        {/ <span style={{ fontSize: '0.8rem', color: '#aaa' }}>Vas o No Vas</span> /}

                        <span style={{ 
                            fontSize: '0.8rem', padding: '3px 8px', borderRadius: '12px', fontWeight: 'bold',
                            backgroundColor: connectionStatus === 'connected' ? '#198754' : '#dc3545' 
                        }}>
                            {connectionStatus === 'connected' ? 'En línea' : 'Desconectado'}
                        </span>
                    </div> */}

                    <span style={{ display: 'block', width: 'fit-content', fontSize: '0.8rem', padding: '3px 8px', borderRadius: '12px', fontWeight: 'bold',
                        margin: '1em auto', backgroundColor: connectionStatus === 'connected' ? '#198754' : '#dc3545' 
                    }}>
                        {connectionStatus === 'connected' ? 'En línea' : 'Desconectado'}
                    </span>

                    <p style={{ margin: 0, color: '#ffd700' }}> {/* fontWeight: '900', fontSize: '1em', textTransform: 'uppercase' */}
                        {getInstructionText()}
                    </p>
                </header>

                {/* CUADRÍCULA DE MALETINES */}
                <div style={{ flexGrow: 1, overflowY: 'auto', padding: '15px' }}>
                    {matchState.briefcases.length === 0 ? (
                        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.5, textAlign: 'center' }}>
                            <p>Esperando que inicie la dinámica...</p>
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)', // 3 columnas para celular queda perfecto
                            gap: '10px',
                            justifyContent: 'center'
                        }}>
                            {matchState.briefcases.map(bc => {
                                const isClickable = matchState.phase === 'SELECTING_MAIN' && bc.state === 'closed';
                                const isMyBriefcase = matchState.userSelectedBriefcaseId === bc.id;
                                const isTargetedBriefcase = matchState.targetedBriefcaseId === bc.id;
                                
                                return (
                                    <div 
                                        key={bc.id}
                                        onClick={() => handleBriefcaseSelection(bc.id)}
                                        style={{
                                            position: 'relative',
                                            aspectRatio: '1/1',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            backgroundImage: `url(${bc.state === 'opened' ? ASSETS.opened : ASSETS.closed})`,
                                            backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
                                            opacity: bc.state === 'opened' ? 0.3 : 1,
                                            filter: isMyBriefcase ? 'drop-shadow(0 0 15px rgba(255,215,0,0.8))' : 'none',
                                            transform: isMyBriefcase ? 'scale(1.1)' : 'scale(1)',
                                            transition: 'all 0.3s ease',
                                            cursor: isClickable ? 'pointer' : 'default'
                                        }}
                                    >
                                        {/* Solo mostrar número si no está abierto */}
                                        {bc.state !== 'opened' && (
                                            <span style={{
                                                fontSize: '1.5rem', fontWeight: '900', color: '#111',
                                                textShadow: '1px 1px 0px rgba(255,255,255,0.5)',
                                                marginTop: '10%'
                                            }}>
                                                {bc.id}
                                            </span>
                                        )}

                                        {/* Insignia si es mi maletín */}
                                        {isMyBriefcase && (
                                            <div style={{
                                                position: 'absolute', bottom: '10px', //right: '-10px',
                                                backgroundColor: '#dc3545', color: 'white', fontSize: '0.6rem',
                                                fontWeight: 'bold', padding: '2px 6px', borderRadius: '10px',
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.5)'
                                            }}>
                                                Este es tuyo
                                            </div>
                                        )}

                                        {/* Insignia ABRIR ESTE (CYAN) */}
                                        {isTargetedBriefcase && (
                                            <div style={{
                                                position: 'absolute', bottom: '10px', //right: '-10px',
                                                backgroundColor: '#0dcaf0', color: '#000', fontSize: '0.6rem',
                                                fontWeight: 'bold', padding: '2px 6px', borderRadius: '10px',
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.5)'
                                            }}>Abramos éste</div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <p className='FooterCredits' style={{ textAlign: 'center', zIndex: '12', color: '#fff', fontSize: '18px' }}>Hecho con ♥ por Interaktia | 2026</p>

                {/* TOAST / ALERTAS */}
                {toastMessage && (
                    <div style={{
                        position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
                        backgroundColor: '#198754', color: 'white', padding: '8px 16px', borderRadius: '20px',
                        fontWeight: 'bold', fontSize: '0.9rem', boxShadow: '0 4px 10px rgba(0,0,0,0.5)', zIndex: 100
                    }}>
                        {toastMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export { Briefcase };